import type { AppRouteObject } from "../routes";
import { SessionsRoute } from "./routes/Sessions";

const routes: AppRouteObject[] = [SessionsRoute];

export default routes;
